var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/bar.js
// module id = 1109
// module chunks = 0